import React from 'react'
import { useTranslation } from 'next-i18next'
import { MdOutlineKeyboardDoubleArrowDown } from 'react-icons/md'
import { RxArrowTopRight } from 'react-icons/rx'
import Link from 'next/link'
import { trackApplyButton } from '@/utils/dataLayer'

const BeAPartner = () => {
    const { t } = useTranslation()

    const features = [
        t('contact-us-page.be-a-partner.feature-1'),
        t('contact-us-page.be-a-partner.feature-2')
    ]

    return (
        <div className="w-full max-w-[90%] mx-auto my-[80px] md:my-[100px]">
            <div className="flex flex-col lg:flex-row gap-[40px] md:gap-[24px] items-center">
                <div className="flex-1 bg-[#FE5351] rounded-[40px] md:rounded-[60px] px-[16px] md:px-[48px] py-[60px] md:py-[100px] flex flex-col justify-between w-full md:min-w-[60%]">
                    <div className="flex flex-col gap-[20px] md:gap-[24px]">
                        <h2 className="text-white text-[20px] xs:text-[28px] md:text-[32px] lg:text-[40px] font-[700] leading-[120%]">
                            {t('contact-us-page.be-a-partner.title')}
                        </h2>
                        <p className="text-white text-[14px] xs:text-[18px] leading-[150%]">
                            {t('contact-us-page.be-a-partner.description')}
                        </p>
                    </div>
                    <Link href="/apply" className="mt-[16px] flex justify-end" onClick={() => trackApplyButton("be_a_partner")}>
                        <button className="w-[200px] h-[56px] bg-white/20 border border-white rounded-full text-white font-[500] text-[14px] md:text-[16px] flex items-center justify-center gap-[8px] hover:bg-white hover:text-main-pink transition duration-300">
                            <span>{t('contact-us-page.be-a-partner.button')}</span>
                            <RxArrowTopRight className="w-[18px] h-[18px]" />
                        </button>
                    </Link>
                </div>

                <div className="flex-1 bg-[#F5F7F9] rounded-[12px] px-[20px] py-[40px] w-full md:min-w-[40%] h-min">
                    <div className="flex flex-col gap-[20px]">
                        <h3 className="bg-gradient-to-b from-[#091F59] to-[#1A3884] text-transparent bg-clip-text text-[20px] font-[600]">
                            {t('contact-us-page.be-a-partner.info-title')}
                        </h3>
                        <p className="text-[#202020CC] text-[16px] leading-[150%]">
                            {t('address')}
                        </p>
                        {/* <div className="flex flex-col gap-[16px] md:gap-[20px]">
                            {features.map((feature, index) => (
                                <div key={index} className="flex items-center gap-[12px]">
                                    <div className="flex-shrink-0 w-[24px] h-[24px] md:w-[32px] md:h-[32px] rounded-full bg-gradient-to-b from-[#091F59] to-[#1A3884] flex items-center justify-center">
                                        <MdOutlineKeyboardDoubleArrowDown className="w-[20px] h-[20px] text-white" />
                                    </div>
                                    <p className="text-[#222222] text-[14px] leading-[150%] flex-1">
                                        {feature}
                                    </p>
                                </div>
                            ))}
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BeAPartner
